import styled, { css } from 'styled-components';

import { ThemeProp } from '~/theme/Themes';
import { hex2rgba } from '~/utils/helpers';

export const CardContainer = styled.div<{ $inactive?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin: 0.5rem 0;
  padding: 0.875rem;
  border: 1px solid ${(props: ThemeProp) => props.theme.colors.neutrals.c100};
  border-radius: 0.75rem;
  background-color: ${(props: ThemeProp) => props.theme.colors.neutrals.white};

  ${(props) =>
    props.$inactive &&
    css`
      opacity: 0.7;
    `}
`;

export const CardTitle = styled.div`
  font-size: ${(props: ThemeProp) => props.theme.fontSize.s};
  font-weight: ${(props: ThemeProp) => props.theme.fontWeight.semibold};
  color: ${(props: ThemeProp) => props.theme.colors.neutrals.black};
`;

export const CardSummary = styled.div`
  font-size: ${(props: ThemeProp) => props.theme.fontSize.s};
  color: ${(props: ThemeProp) => props.theme.colors.neutrals.c400};
  overflow-wrap: anywhere;
`;

export const CardWarning = styled.div`
  padding: 0.5rem 0.625rem;
  border-radius: 0.5rem;
  background-color: ${(props: ThemeProp) => hex2rgba(props.theme.colors.warningYellow, 0.1)};
  font-size: ${(props: ThemeProp) => props.theme.fontSize.xs};
  color: ${(props: ThemeProp) => props.theme.colors.neutrals.black};
  overflow-wrap: anywhere;
`;

export const FieldsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const FieldRow = styled.label`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

export const FieldLabel = styled.span`
  font-size: ${(props: ThemeProp) => props.theme.fontSize.xs};
  font-weight: ${(props: ThemeProp) => props.theme.fontWeight.medium};
  color: ${(props: ThemeProp) => props.theme.colors.neutrals.c400};
`;

export const FieldInput = styled.input`
  width: 100%;
  height: 2rem;
  padding: 0 0.5rem;
  border: 1px solid ${(props: ThemeProp) => props.theme.colors.neutrals.c100};
  border-radius: 0.5rem;
  font-size: ${(props: ThemeProp) => props.theme.fontSize.s};
  color: ${(props: ThemeProp) => props.theme.colors.neutrals.black};
  background-color: ${(props: ThemeProp) => props.theme.colors.neutrals.white};

  &:focus {
    outline: none;
    border-color: ${(props: ThemeProp) => props.theme.colors.aiOrange};
  }

  &:disabled {
    background-color: ${(props: ThemeProp) => props.theme.colors.neutrals.c050};
    color: ${(props: ThemeProp) => props.theme.colors.neutrals.c400};
  }
`;

export const FieldCheckbox = styled.input`
  width: 1rem;
  height: 1rem;
  align-self: flex-start;
`;

export const FieldJsonValue = styled.pre`
  margin: 0;
  padding: 0.5rem;
  max-height: 10rem;
  overflow: auto;
  border: 1px solid ${(props: ThemeProp) => props.theme.colors.neutrals.c100};
  border-radius: 0.5rem;
  background-color: ${(props: ThemeProp) => props.theme.colors.neutrals.c050};
  font-size: ${(props: ThemeProp) => props.theme.fontSize.xs};
  color: ${(props: ThemeProp) => props.theme.colors.neutrals.black};
  white-space: pre-wrap;
  overflow-wrap: anywhere;
`;

export const CardActions = styled.div`
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
`;

export const CardStatus = styled.div`
  font-size: ${(props: ThemeProp) => props.theme.fontSize.s};
  font-weight: ${(props: ThemeProp) => props.theme.fontWeight.medium};
  color: ${(props: ThemeProp) => props.theme.colors.neutrals.c400};
`;

export const CardError = styled.div`
  font-size: ${(props: ThemeProp) => props.theme.fontSize.xs};
  color: ${(props: ThemeProp) => props.theme.colors.errorRed};
`;
